<template>
	<div class="calendarContent">
		<table>
			<thead v-once>
				<tr>
					<th :key="day" v-for="day in getDaysOfWeek">{{ day }}</th>
				</tr>
			</thead>
			<tbody>
			<tr :key="idx" v-for="(dateItem, idx) in calendarDates">
				<td :key="item.id" v-for="item in dateItem">
					<div class="itemTd" :class="{'focusBlock': focusBlock === item.date}" @click="onFocusBlock(item.date)" @dblclick="onPayments(item.date)">
			      <svg-sprite v-if="item.pause" width="16" height="16" icon-id="not_pay"></svg-sprite>
						<span class="itemTd_dateNumber" :class="{'active': item.isToday}">
								{{ item.numberOfDay }}
						</span>
						<div v-if="item.list" class="paymentsList">
							<span :key="body.id" v-for="body in item.list.slice(0, 2)" :title="body.text" class="paymentsList_item">{{ body.text }}</span>
							<span v-if="item.list.length > 2" class="paymentsList_item more">
								<svg-sprite width="18" height="4" icon-id="ellipsis"></svg-sprite>
							</span>
						</div>
					</div>
				</td>
			</tr>
			</tbody>
		</table>
		<preload v-if="isPreload" isAbsolute></preload>
	</div>
</template>

<script>
import Preload from "@/shared/Preload/Preload";
// constants
import { daysOfWeek } from "@/pages/Accounting/Calendar/constants";

export default {
	name: "CalendarContent",
	components: {
		Preload
	},
	computed: {
		getDaysOfWeek() {
			return daysOfWeek;
		}
	},
	props: {
		calendarDates: Array,
		isPreload: Boolean
	},
	data: () => ({
		focusBlock: null
	}),
	methods: {
		onPayments(date) {
			this.$emit('updateDetailsPayments', date);
		},
		onFocusBlock(value) {
			this.focusBlock = value;
		}
	}
};
</script>

<style scoped lang="scss">
@import "calendarContent";
</style>
